module.exports = window.VueAwesomeSwiper || {};